module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-appbar', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "left": "0",
      "z-index": "1001"
    }
  }, [_c('mu-list-item', {
    attrs: {
      "solt": "left",
      "disabled": ""
    }
  }, [_c('mu-avatar', {
    staticClass: "user-img",
    attrs: {
      "slot": "leftAvatar",
      "backgroundColor": "blue",
      "src": "../../../../static/images/logo_white.png"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('span', {
    staticClass: "logo",
    domProps: {
      "innerHTML": _vm._s(_vm.gName)
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCount),
      expression: "showCount"
    }],
    staticClass: "divier",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCount),
      expression: "showCount"
    }],
    attrs: {
      "slot": "right",
      "titleClass": "online-serve"
    },
    on: {
      "click": _vm.toCount
    },
    slot: "right"
  }, [_c('allTrainTimes')], 1), _vm._v(" "), _c('mu-list-item', {
    staticClass: "divier",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-list-item', {
    staticClass: "zhiCustomBtn",
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    },
    attrs: {
      "slot": "right",
      "id": "zhichiBtnBox",
      "titleClass": "online-serve"
    },
    slot: "right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sobot.com/chat/pc_new/index.html?sysNum=a523d1984e4c4b24b485096788a3ee81&color=09aeb0&lan=c",
      "target": "_black"
    }
  }, [_c('span', [_vm._v("在线客服")])])]), _vm._v(" "), _c('mu-list-item', {
    staticClass: "divier",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "slot": "right",
      "titleClass": "login-user",
      "title": _vm.store.account.name
    },
    on: {
      "click": _vm.openMenu
    },
    slot: "right"
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": _vm.imgPath,
      "onerror": "this.src='/public/image/patient.png';this.onerror=null;"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('mu-icon-menu', {
    attrs: {
      "slot": "right",
      "open": _vm.showMenu,
      "icon": "more_vert",
      "iconClass": "iconClass"
    },
    on: {
      "close": _vm.closeMenu
    },
    slot: "right"
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "账户信息"
    },
    on: {
      "click": _vm.toSet
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "block",
      "width": "112px",
      "height": "48px",
      "line-height": "48px",
      "color": "#444",
      "font-size": "16px",
      "padding": "0 16px"
    },
    attrs: {
      "href": "http://jsform3.com/f/5a798446e7aea961dad8abb0",
      "target": "_black"
    }
  }, [_vm._v("使用反馈")]), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "更新日志"
    },
    on: {
      "click": _vm.seeLog
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "退出"
    },
    on: {
      "click": _vm.logout
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac529c0c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/doc/topmenu.vue
// module id = 1024
// module chunks = 2